import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { getLicenciaDetalle } from '../api/consulaLicenciaApi';
import { UseAuth } from "../hooks/useAuth";
import { withRouter } from "../hooks/withRouter";

function BusquedaLicenciaDetalle(props) {
    const { location } = props.router;

    const [result, setResult] = useState([]);
    const url = location.pathname.split("/");
    const id = url[2];
    const { accessToken } = UseAuth();

    useEffect(() => {
        getLicenciaDetalle(accessToken, id).then((response) => {
            if (response?.code !== 200) {
                setResult(response);
            } else {
            }
        }).catch(() => {
        });
    }, [accessToken,id]);

    const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);

    const day = d.getUTCDate();
    const month = d.getUTCMonth() + 1;
    const year = d.getUTCFullYear();

    return `${day.toString().padStart(2, '0')}/${month
        .toString()
        .padStart(2, '0')}/${year}`;
};


    if (result.length < 1) {
        return "loading";
    }

    return (
        <div>
            <div className='top-bar2'>
                <div className="top-bar">
                    <div className="logo">
                        {/* Botón con apariencia de logo que lleva a la página principal */}
                        <Link to="/">
                            <button className="logo-button">
                                <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            <>
            <div class="acta-container">
                            <h1>Padron Licencias</h1>
                {result.map((res, index) => (
                    <div key={index}>
                        <h1>{res.NOMBRE}</h1>
                        <div className="acta" >
                            <div className='column2'>
                                {res.FOTO_IMAGEN && <img src={FOTO(res.FOTO_IMAGEN.data, res.FOTO_IMAGEN.type)} alt="Foto" style={{ width: '120%', height: '40%', marginBottom: '15%' }} />}
                                <div>
                                    {res.FIRMA_IMAGEN && <img src={FOTO(res.FIRMA_IMAGEN.data, res.FIRMA_IMAGEN.type)} alt="Firma" style={{ width: '120%', height: '40%', marginRight: '15%', marginBottom: '20px' }} />}
                                </div>
                                <div>
                                    {res.FOTO_DERECHO && <img src={FOTO(res.FOTO_DERECHO.data, res.FOTO_DERECHO.type)} alt="DERECHO" style={{ width: '40%', height: ' 220px ', marginRight: '1%' }} />}
                                    {res.FOTO_IZQUIERDO && <img src={FOTO(res.FOTO_IZQUIERDO.data, res.FOTO_IZQUIERDO.type)} alt="IZQUIERDO" style={{ width: '40%', height: '220'}} />}
                                </div>
                                <h1>No.Licencia  </h1>
                                <p className="letra">  {res.NO_LICENCIA} </p>
                            </div>

                            <div className='column'>
                                <h1>RFC</h1>
                                <p className="letra">{res.RFC}</p>
                                <h1>CURP</h1>
                                <p className="letra">{res.CURP}</p>
                                <h1>Nombre</h1>
                                <h1>{res.NOMBRE}</h1>
                                <h1> Domicilio</h1>
                                <p className="letra">{res.DOMICILIO}</p>
                                <h1>Tipo de Licencia</h1>
                                <p className="letra">{res.TIPO_LICENCIA}</p>
                                <h1> Nacionalidad</h1>
                                <p className="letra">{res.DESCRIPCION}</p>
                                <h1>Notificar A</h1>
                                <p className="letra">{res.NOTIFICAR_A}</p>
                                <h1> Telefono A Notificar</h1>
                                <p className="letra">{res.TELEFONO_A_NOTIFICAR}</p>
                                <h1>Sexo</h1>
                                <p className="letra">{res.SEXO}</p>
                                <h1>Fecha de Nacimiento </h1>
                                <p className="letra">{formatDate(res.FECHA_NACIMIENTO)}</p>
                            </div>

                            <div className='column'>
                                <h1>Fecha De Expedicion</h1>
                                <p className="letra">{formatDate(res.FECHA_EXPEDICION)}</p>
                                <h1>Fecha De Vigencia</h1>
                                <p className="letra">{formatDate(res.FECHA_VIGENCIA)}</p>
                                <h1> Tipo De Sangre </h1>
                                <p className="letra">{res.TIPO_SANGRE}</p>
                                <h1>Estatura</h1>
                                <p className="letra">{res.ESTATURA}</p>
                                <h1> Complexion</h1>
                                <p className="letra">{res.COMPLEXION}</p>
                                <h1>Color De Ojos</h1>
                                <p className="letra">{res.COLOR_OJOS}</p>
                                <h1> Color De Piel</h1>
                                <p className="letra">{res.PIEL}</p>
                                <h1>Usa Lentes</h1>
                                <p className="letra">{res.LENTES}</p>
                                <h1>Es Donador </h1>
                                <p className="letra">{res.DONADOR}</p>
                                <h1> Lugar De Tramite</h1>
                            </div>
                        </div>
                    </div>
                ))}
                        </div>

            </>
        </div>
    );
}

function FOTO(data, type) {
    const imageBlob = new Blob([new Uint8Array(data)], { type: type });
    return URL.createObjectURL(imageBlob);
}

export default withRouter(BusquedaLicenciaDetalle);
